import type { GivingContentObjectDetail, GivingInterval } from 'models';
import { useCallback } from 'react';
import {
  type AdditionalInfoFormValues,
  type FormValuesAmount,
  GivingCreateForm,
  GivingImageWithTitle,
  type RecurringFormValues,
} from '../../../../../../components';
import { useGiveNow } from '../../../../context';

type CreateGiveNowValues = FormValuesAmount & Omit<AdditionalInfoFormValues, 'reason'> & RecurringFormValues;

type P = {
  givingContentObject: GivingContentObjectDetail;
  interval: GivingInterval;
  onClose: () => void;
};

const GiveNowCreateForm = ({ givingContentObject, interval, onClose }: P) => {
  const { addItem, createItem, getItem, updateItem } = useGiveNow();
  const { giving } = givingContentObject;
  const savedGive = getItem(giving.id);

  const handleCancel = useCallback(() => {
    onClose();
  }, [onClose]);

  const onSuccess = (value: CreateGiveNowValues) => {
    const giveItem = createItem({ ...value, recurring: interval }, givingContentObject);
    savedGive ? updateItem(savedGive.id, giveItem) : addItem(giveItem);
    onClose();
  };

  const defaultValuesAmount: FormValuesAmount = {
    amount: savedGive?.amount ?? 0,
    showCustomAmount: false,
  };

  const defaultValuesCustomAmount: FormValuesAmount = {
    customAmount: savedGive?.amount ?? 0,
    showCustomAmount: true,
  };

  const initialValues = {
    ...(savedGive?.showCustomAmount ? defaultValuesCustomAmount : defaultValuesAmount),
    displayName: Boolean(savedGive?.displayName),
    recurring: savedGive?.recurring,
    showRecurring: Boolean(savedGive?.recurring),
  };

  return (
    <>
      <GivingImageWithTitle giving={giving} titleLevel={3} />

      <GivingCreateForm
        giving={giving}
        initialValues={initialValues}
        interval={interval}
        onCancel={handleCancel}
        onSuccess={onSuccess}
        type="giveNow"
      />
    </>
  );
};

export default GiveNowCreateForm;
